<template>
<div id="container" class="container escaperoom">
  <div class="fullscreen_background">
    <img src="/static/assets/escaperoom/Hintergrund_2860.png" />
  </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
  <div class="Spinne">
   <img class="img" src="/static/assets/escaperoom/Hugidubies_Website_Animation_3_Escaperoom_Spinne_2.png" />
  </div>
	<div class="Stimme">
    <img class="img" src="/static/assets/escaperoom/animation_Stimme_des_Grauens.png" />
  </div>
	<div class="animation_dubix Z40">
    <img class="img" src="/static/assets/escaperoom/animation_Dubix.png" />
  </div>
  <div class="gigi z30">
    <img class="img" src="/static/assets/escaperoom/Libero_langdon.png"/>
  </div>
  <div class="libero z30"><img class="img" src="/static/assets/escaperoom/Hugi_clever.png" /></div>
  <div class="buecher_01 z30">
    <img class="img" src="/static/assets/escaperoom/Vektor-Smartobjekt.png" />
  </div>
  <div class="buecher_02 z30">
    <img class="img" src="/static/assets/escaperoom/Vektor-Smartobjekt2.png" />
  </div><div class="hugi z30"><img class="img" src="/static/assets/escaperoom/gigi_hari.png" /></div>
  <div class="dubix z30">
    <img class="img " src="/static/assets/escaperoom/Gundi_kuhn.png" />
  </div>
  <div class="daddelmayer_herr z30">
    <img class="img " src="/static/assets/escaperoom/Herr_daddelmayer.png" />
  </div>
  <div class="daddelmayer_frau z35">
        <img class="img" src="/static/assets/escaperoom/frau_daddelmayer.png" />
    </div>
<div class="verlauf Z40">
    <img class="img" src="/static/assets/escaperoom/Verlauf.png" />
  </div>  <!-- <router-link to="/maerchengeschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/escaperoom/Pfeil.png" />
    </router-link> -->
  <!--div class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/escaperoom/Pfeil-1.png" />
    </div-->

  <router-link to="/geschichte_200603" tag="div" class="pfeil_links_big z50 pointer">
    <img class="img" src="/static/assets/alle/Pfeil.png" />
  </router-link>
  <router-link tag="div" to="dinowelt" class="pfeil_rechts_big z50 pointer">
    <img class="img" src="/static/assets/alle/Pfeil-1.png" />
  </router-link>

  <div class="geschichte z45">
    <div class="inner">
      <img src="/static/assets/escaperoom/Textfeld.png" usemap="#geschichte-map">
      <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Geschichten_Langsam_HugiClever.mp3" jsonurl="/static/assets/geschichten/hugi_ausgabe_6.json" content=".escaperoom" target="escaperoom_target" />
      <vuescrollbar tag="div" class="fliesstext" id="escaperoom_target">
<p>„Willkommen in Daddelmayers Escape-Room“ stand an der schweren Eisentür. Sie ließ sich leicht öffnen und führte zum Kellergewölbe von Burg Greifenklau. Die Hugidubies und ihre Freundin Gundi Kuhn blickten auf eine steile, dunkle Treppe hinab. „Ob da unten wohl Verliese sind?“, flüsterte Gigi Hari. „Oder ein Geheimgang, der aus der Burg führt?“, rätselte Dubix Fox. Schon nahm er Libero Langdon auf den Arm und setzte seine Füße auf die Stufen. Gigi Hari und Gundi Kuhn schlossen sich ihm an. Hugi Clever hörte sein Herz pochen. Warum musste er das mitspielen? Na ja, wenigstens hatte er sich für alle Fälle ausgerüstet. Sollen sich die anderen doch über ihn lustig machen. „Wer Angst hat, ist schlau, weil er Gefahren erkennt!“, redete er sich gut zu und betrat als Letzter die Treppe.</p>
<p>Wumms! Da flog die dicke, eiserne Tür zu und es war stockfinster! Sie tasteten sich zur Tür zurück und versuchten sie zu öffnen. Vergebens! Hugi Clever wandte sich wieder der Treppe zu. „Da, seht!“, wisperte er. Am Treppenabgang hing ein Leuchtschild, „Escape“ stand darauf geschrieben. Was blieb ihnen anderes übrig, als dem Schild, das ein wenig Licht auf die Treppe warf, zu folgen?</p>
<p>Am Treppenabsatz schlängelte sich ein langer, düsterer Gang zu einer alten, niedrigen Holztür. Hugi Clever holte eine riesige Taschenlampe aus seinem Rucksack und schaltete sie ein. „Angsthase!“, nannte ihn Gigi Hari, lief auf die Tür zu und öffnete sie. Anstatt eines Verlieses erwartete sie ein Raum, dessen Wände über und über mit Bildern und Spiegeln behängt waren, in denen sich das Licht der Taschenlampe brach, wodurch es den Raum erhellte. Wumms! Die Tür, durch die sie gekommen waren, fiel zu und ließ sich nicht mehr öffnen. Auch die Tür am anderen Ende des Raums war verschlossen. Die Hugidubies sahen sich ratlos an. Wie sollten sie da wieder herauskommen? „Gut, dass du eine Lampe dabeihast“, sagte Dubix Fox zu Hugi Clever. „Ja, manchmal sind Angsthasen ganz brauchbar“, antwortete der, als sich plötzlich die Stimme des Grauens erhob: „Zwei Mütter und zwei Töchter stellen sich nebeneinander vor einen großen Spiegel. Doch im Spiegelbild sind nur drei Personen zu sehen. Wie kann das geschehen?“ „Haha, superwitzig. Gar nicht kann das geschehen. Vier bleibt vier!“, spottete Dubix Fox laut, um seinen Schreck zu übertönen. Doch Hugi Clever brachte die eigene Furcht zum Nachdenken. „Klar. Oma, Mama, Tochter. Macht zwei Töchter und zwei Mamas, aber nur drei Personen“, überlegte er laut. „Genau wie da!“, bemerkte Gundi Kuhn und berührte ein Bild, das zwei Frauen und ein Mädchen zeigte. Quietsch, ging die verschlossene Tür auf. Libero Langdon bellte aufgeregt und sprang aus den Armen von Dubix Fox in den neuen Raum. Die anderen liefen ihm nach.</p>
<p>Wumms! Wieder fiel die Tür hinter ihnen ins Schloss. Na, das hatte hier Methode! Der neue Raum war klein und fast leer. Nur in seiner Mitte stand ein brüchiger Tisch, auf dem ein Papierbogen und Stifte lagen. „Toll, was soll das denn?“, regte sich Gundi Kuhn auf und nahm den Zettel in die Hände. „Da steht absolut nichts drauf.“ „Da wäre ich mir nicht so sicher!“, erwiderte Hugi Clever und gab Dubix Fox seine Taschenlampe. Dann nahm er zielsicher einen der Stifte vom Tisch, drehte an dessen Ende, so dass er blau leuchtete. „Geheimstift“, erklärte er und entriss der staunenden Gundi Kuhn das Papier. Jetzt zeigten sich dort Buchstaben und Hugi Clever las: „Zieht am Nagel.“ Dubix Fox leuchtete die Wände nach einem Nagel ab. „Da!“, lachte Gigi Hari, rannte zur Tür und zog an dem großen, rostigen Nagel, der dort aus der Wand ragte. Quietsch, öffnete sich die Tür und fiel, wumms, wieder zu, sobald die fünf einen weiteren, hell erleuchteten Raum betreten hatten. „Wow!“, jubelte Dubix Fox, „ein Bücherlager!“ Neugierig schauten sie sich um und entdeckten auf einem Bücherstapel schon das nächste Rätsel, das zu knacken war: Wie lautet der Öffnungszauber, der an der berühmtesten Zauberschule der Welt gelehrt wird? Hugi Clever war ein Fan von magischen Büchern und rief: „Alohomora!“</p>
<p>Da ging die Tür auf und Frau und Herr Daddelmayer traten herein: „Bravo! Haben wir uns doch gedacht, dass ihr es schnell aus unserem Escape-Room schaffen werdet! Jetzt wollt ihr euch sicher ein Buch schnappen und zu lesen beginnen. Davor aber müsst ihr das letzte Rätsel lösen. Es lautet: Was lehrt jede Geschichte?“ Vergnügt riefen die vier RätselknackerInnen:</p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
  </div>

</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
/* eslint whitespace: "off" */
/* eslint indent: "off" */
/* eslint keyword-spacing: "off" */
/* eslint no-unused-vars: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Copyright from '@/components/Copyright.vue'
import Snowf from 'vue-snowf'
import Lautsprecher from '@/components/Lautsprecher.vue'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'escaperoom',
  data () {
    return {
      who: 'escaperoom',
      sternchen: '/static/assets/escaperoom/sternchen.png',
      audioposition: 0
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright, 
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () { 
    this.$ga.page(this.$router)
    var self = this
    setTimeout(function () {
      var muted = (typeof self.$root.muted !== 'undefined' ? self.$root.muted : false)
      try {
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
      } catch (e) {
            console.log('pause geht nicht')
      }
      try {
        window.currentAudio.pause()
        window.currentAudio.currentTime = 0
        window.currentAudio = null
      } catch (e) {
            console.log('pause geht nicht')
      }
      window.currentAudioX = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2021_HugiClever.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }

      window.hintergrundSound = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Hugi_Clever_AtmoV5.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined'?   window.muted : false)
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e) {
        window.bgsounddisabled = true
      }


    }, 1000);
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
      console.log('hintergrundsound nicht aktiv')
    }

  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

/* escaperoom */

.escaperoom {
  position: absolute;
  width: 1920px;
  height: 1080px;
  top: 0;
}

.escaperoom .himmel {
  display: block !important;
}

.escaperoom .geschichte {
  position: absolute;
    top: 144px;
    left: 50%;
}

.escaperoom .geschichte .inner {
  position: relative;
}



.escaperoom .pfeil_links_big {
  position: absolute;
  left: 1vw;
  top: 40%;
}

.escaperoom .pfeil_rechts_big {
  position: absolute;
  right: 1vw;
  top: 40%;
}

.escaperoom .moebel_vorne {
  position: absolute;
  bottom: 0;
  left: 0;
}

.escaperoom .miss_witch {
  position: absolute;
  /* top: 50%; left: 21%; */
  top: 47%;
  left: 23%;
}

.escaperoom .hugi {
  position: absolute;
  opacity:0;
  animation: hugi_erscheint 1s;
  animation-fill-mode: forwards;
  animation-delay: 0.75s;
}

@keyframes hugi_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.escaperoom .jongleur {
  opacity:0;
  animation: jongleur_erscheint 1.5s;
  animation-fill-mode: forwards;
  animation-delay: 0.75s;
}

@keyframes jongleur_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
	.escaperoom .trompeter {
  opacity:0;
  animation: trompeter_erscheint 2s;
  animation-fill-mode: forwards;
  animation-delay: 0.75s;
}
@-webkit-keyframes wippen /* Safari and Chrome */ {
  0% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  25% {
    -webkit-transform: rotateX(15deg);
    -o-transform: rotateX(15deg);
    transform: rotateX(15deg);
  }
  50% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  75% {
    -webkit-transform: rotateX(-15deg);
    -o-transform: rotateX(-15deg);
    transform: rotateX(-15deg);
  }
  100% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
}
@keyframes wippen {
  0% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  25% {
    -webkit-transform: rotateX(15deg);
    -o-transform: rotateX(15deg);
    -moz-transform: rotateX(15deg);
    transform: rotateX(15deg);
  }
  50% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
  75% {
    -webkit-transform: rotateX(-15deg);
    -o-transform: rotateX(-15deg);
    -moz-transform: rotateX(-15deg);
    transform: rotateX(-15deg);
  }
  100% {
    -webkit-transform: rotateX(0deg);
    -o-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }
}
.escaperoom .spotlight1 img{animation: spotlight1_erscheint 3s ease-out; animation-delay: 0s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes spotlight1_erscheint {
    0% {margin-left: 1000px; opacity:0;}
    50% { opacity:0.5;}
    100% {margin-left: 0px; opacity:1;}
}
	.escaperoom .spotlight2 img{animation: spotlight2_erscheint 3s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes spotlight2_erscheint {
    0% {margin-top: -250px; opacity:0;}
    100% {margin-top: 0px; opacity:0.75;}
}
		.escaperoom .spotlight3 img{animation: spotlight3_erscheint 2s ease-out; animation-delay: 3s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes spotlight3_erscheint {
    0% {margin-top: -250px; opacity:0;}
    100% {margin-top: 0px; opacity:0.75;}
}
.escaperoom .wippen {
  -webkit-animation: wippen 4s linear infinite;
  -moz-animation: wippen 4s linear infinite;
  -ms-animation: wippen 4s linear infinite;
  -o-animation: wippen 4s linear infinite;
  animation: wippen 4s linear infinite;
}
@keyframes trompeter_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.escaperoom .libero {
  position: absolute;
top: 750px;
    left: 210px;
}

.escaperoom .libero {
  animation: libero_erscheint 0.5s ease-out;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes libero_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.escaperoom .zampano {
  position: absolute;
    top: 369px;
    left: 784px;
}

.escaperoom .zampano img {
  animation-delay: 8s;
  animation: zampano_erscheint 1s;
  transform-origin: bottom center;
}

@keyframes zampano_erscheint {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  80% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.escaperoom .fliesstext {
  bottom: 208px;
  left: 9.5%;
  width: 79%;
  font-size: 16pt;
  font-family: 'Open Sans';
  font-weight: 400;
  position: absolute;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 450px;
  padding-right: 15px;
}

.escaperoom div.fliesstext>span {
  margin-right: 8px !important;
  float: left !important;
}

::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px #ac8a69;
  box-shadow: inset 0 0 0px #ac8a69;
  -webkit-border-radius: 0;
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #ac8a69;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #ac8a69;
}

::-webkit-scrollbar-button {
  background: none;
}

::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat;
}

::-webkit-scrollbar-button:vertical:decrement {
  background-image: url(http://www.fruehling.eu/wp-content/uploads/2018/02/arrow_up.png);
  background-position: 0px 0px;
}

::-webkit-scrollbar-button:vertical:increment {
  background-image: url(http://www.fruehling.eu/wp-content/uploads/2018/02/arrow_do.png);
  background-position: 0px 0px;
}

.snowf-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 150% !important;
  height: 150% !important;
  left: -25% !important;
  z-index: 30 !important;
}

.dubix_animation {
  width: 320px;
  height: 320px;
  background: url('/static/assets/escaperoom/01_zirkusmeister_Dubix.png') top center;
  transform: scale(1);
  margin-top: -25px;
  margin-left: -50px;
}
  
.escaperoom .animation_dubix {
    position: absolute;
    top: -260px;
    left: -500px;
  animation: dubix_erscheint 1s ;
  animation-fill-mode: forwards;
  animation-delay: 0s;
  opacity: 0;
}  
.escaperoom .daddelmayer_herr.z30 {
    position: absolute;
    top: 630px;
    left: 763px;
  animation: dubix_erscheint 1s ;
  animation-fill-mode: forwards;
  animation-delay: 2.25s;
  opacity: 0;
}
.escaperoom .daddelmayer_frau.z35 {
    position: absolute;
    top: 650px;
    left: 862px;
  animation: dubix_erscheint 1s ;
  animation-fill-mode: forwards;
  animation-delay: 3s;
  opacity: 0;
}
.escaperoom .Stimme {
    position: absolute;
    top: -280px;
    left: -484px;
}
.escaperoom .Spinne {
    position: absolute;
    top: -690px;
    left: -400px;
  animation: spinne_erscheint 25s ;
  animation-fill-mode: forwards;
  animation-delay: 0.25s;
}  
  
@keyframes spinne_erscheint {
  50% {
    top: -690px;
  }
  100% {
    top: 0;
  }
}  
.escaperoom .verlauf.Z40 img {
    width: 120%;
    height: 120%;
}
.escaperoom .verlauf.Z40 {
    position: absolute;
    top: -10%;
    left: -10%;
} 
.escaperoom .gigi {
    position: absolute;
top: 816px;
    left: 850px;
    opacity: 0;
    animation: gigi_erscheint 3s ;
  animation-fill-mode: forwards;
  animation-delay: 0.25s;
}

@keyframes gigi_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes play_dubix {
  0% {
    background-position: 0 0px;
  }
  50% {
    background-position: 0 -1600px;
  }
  100% {
    background-position: 0 -1600px;
  }
}

.globus {
  width: 350px;
  height: 350px;
  background: url('/static/assets/escaperoom/01_Globus_1.png') top center;
  animation-delay: 2s;
  animation: play_globus 4s steps(6) infinite;
  transform: scale(0.465);
  top: -87px;
  left: 849px;
  position: absolute;
}

@keyframes play_globus {
  0% {
    background-position: 0 0px;
  }
  50% {
    background-position: 0 -2100px;
  }
  100% {
    background-position: 0 -2100px;
  }
}
.kerze {
    width: 380px;
    height: 529px;
    background: url(/static/assets/escaperoom/01_Kerze_1.png) top center;
    animation: play_kerze 2s steps(8) infinite;
    transform: scale(0.26);
    top: 533px;
    left: 728px;
    position: absolute;
}

@keyframes play_kerze {
  0% {
    background-position: 0 0px;
  }
  100% {
    background-position: 0 -4232px;
  }
}
.dubix.z30 {
  position: absolute;
  top: 544px;
    left: 562px;
    animation: dubix_erscheint 1s ;
  animation-fill-mode: forwards;
  animation-delay: 0.25s;
  opacity: 0;
}

@keyframes dubix_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.escaperoom .hugi {
    position: absolute;
    top: 672px;
    left: 465px;
}
	.escaperoom .jongleur {
    position: absolute;
    top: 465px;
    left: 380px;
}
.escaperoom .trompeter {
    position: absolute;
top: 712px;
    left: 399px;
}
.escaperoom .spotlight1, .escaperoom .spotlight2 {
    position: absolute;
    top: -130px;
    left: 850px;
} 
.escaperoom .spotlight3 {
    position: absolute;
    top: 0px;
    left: 290px;
}
	.escaperoom .zampana {
    position: absolute;
    top: -280px;
    left: -450px;
}
.dubix {
  transform-origin: bottom center;
}


@keyframes jongleur_animation {
  100% {
    background-position: 0 -1760px;
  }
}
	.zampano_animation {
  width: 610px;
  height: 682px;
  background: url('/static/assets/escaperoom/zampano_animation.png') top center;
  animation-delay: 2s;
  animation: zampano_animation 3s steps(10) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes zampano_animation {
  100% {
    background-position: 0 -6820px;
  }
}
.hovering {
  -webkit-animation: hovering 8s ease-in-out infinite;
  -moz-animation: hovering 8s ease-in-out infinite;
  -ms-animation: hovering 8s ease-in-out infinite;
  -o-animation: hovering 8s ease-in-out infinite;
  animation: hovering 8s ease-in-out infinite;
}

@-webkit-keyframes hovering
/* Safari and Chrome */

  {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  50% {
    -ms-transform: translate(0px, 20px);
    -moz-transform: translate(0px, 20px);
    -webkit-transform: translate(0px, 20px);
    -o-transform: translate(0px, 20px);
    transform: translate(0px, 20px);
  }
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

@keyframes hovering {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  /* 25% {
    -ms-transform: translate(-20px,20px);
    -moz-transform: translate(-20px,20px);
    -webkit-transform: translate(-20px,20px);
    -o-transform: translate(-20px,20px);
    transform: translate(-20px,20px);
  }
 */
  50% {
    -ms-transform: translate(0px, 20px);
    -moz-transform: translate(0px, 20px);
    -webkit-transform: translate(0px, 20px);
    -o-transform: translate(0px, 20px);
    transform: translate(0px, 20px);
  }
  /*  75% {

    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
*/
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

span {
  font-family: FrozenMemory;
}
.buecher_01.z30 {
    position: absolute;
    top: 860px;
    left: 80px;
}
.buecher_02.z30 {
    position: absolute;
    top: 1000px;
    left: 650px;
}
</style>



// WEBPACK FOOTER //
// src/components/Escaperoom.vue